// import React, { Fragment, useEffect, useState } from 'react';
// import { Breadcrumbs, H5 } from '../../AbstractElements';
// import { Card, CardBody, CardHeader, Col, Container, Row, Media } from 'reactstrap';
// import { chatList, markSeenAllMessages } from '../../Services/UserService';
// import moment from 'moment';
// import { useNavigate } from 'react-router';

// const ChatList = () => {
//     const [chatUsers, setChatUsers] = useState([]);
//     const navigate = useNavigate();

//     const getChatList = async () => {
//         try {
//             const response = await chatList();
//             if (response.success) {
//                 setChatUsers(response.data);
//             }
//         } catch (error) {
//             console.error("Error fetching chat list:", error);
//         }
//     };

//     useEffect(() => {
//         getChatList();
//     }, []);

//     const chatItemStyle = {
//         padding: '10px',
//         borderRadius: '8px',
//         cursor: 'pointer',
//         transition: 'background 0.2s ease',
//     };

//     const hoverStyle = {
//         backgroundColor: '#fff9e5',
//     };

//     const unreadDotStyle = {
//         width: '10px',
//         height: '10px',
//         backgroundColor: 'red',
//         borderRadius: '50%',
//         marginLeft: 'auto',
//         alignSelf: 'center',
//     };

//     const [hoveredIndex, setHoveredIndex] = useState(null);

//     const handleMarkSeenMessages = async (chat) => {
//         console.log(chat)
//         const passData = {
//             sender_id: chat?.sender_id,
//             receiver_id: chat?.receiver_id,
//         }
//         const response = await markSeenAllMessages(passData);
//         const admin = JSON.parse(localStorage.getItem("user"));

//         const user_id = chat?.sender_id == admin?._id ? chat?.receiver_id : chat?.sender_id;

//         navigate(`/user-chat/${user_id}`, {
//             replace: true,
//             state: { user_id: user_id, full_name: chat?.full_name },
//         });
//     };

//     return (
//         <Fragment>
//             <Breadcrumbs mainTitle='' parent='' title='' />

//             <Container fluid={true}>
//                 <Row>
//                     <Col sm='12'>
//                         <Card>
//                             <CardHeader>
//                                 <H5>{'Chat List'}</H5>
//                             </CardHeader>
//                             <CardBody>
//                                 {chatUsers.length === 0 ? (
//                                     <p>No chats found</p>
//                                 ) : (
//                                     chatUsers.map((chat, index) => (
//                                         <div
//                                             key={index}
//                                             className="d-flex align-items-center mb-2"
//                                             style={{
//                                                 ...chatItemStyle,
//                                                 ...(hoveredIndex === index ? hoverStyle : {})
//                                             }}
//                                             onMouseEnter={() => setHoveredIndex(index)}
//                                             onMouseLeave={() => setHoveredIndex(null)}
//                                             onClick={() => handleMarkSeenMessages(chat)}
//                                         >
//                                             <Media className="d-flex align-items-start w-100">
//                                                 <img
//                                                     className="rounded-circle mr-3"
//                                                     style={{ borderRadius: "2px" }}
//                                                     src={chat.profile_picture}
//                                                     alt={chat.full_name}
//                                                     width="50"
//                                                     height="50"
//                                                 />
//                                                 <Media body style={{ marginLeft: "16px" }}>
//                                                     <h6 className="mb-1">{chat.full_name}</h6>
//                                                     <p className="mb-0 text-muted">{chat.last_message}</p>
//                                                     <small className="text-secondary">
//                                                         {moment(chat.last_message_date).fromNow()}
//                                                     </small>
//                                                 </Media>
//                                             </Media>
//                                             {!chat.last_message_is_seen && (
//                                                 <div style={unreadDotStyle}></div>
//                                             )}
//                                         </div>
//                                     ))
//                                 )}
//                             </CardBody>
//                         </Card>
//                     </Col>
//                 </Row>
//             </Container>
//         </Fragment>
//     );
// };

// export default ChatList;



























import React, { Fragment, useEffect, useState } from 'react';
import { Breadcrumbs, H5 } from '../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row, Media, Input } from 'reactstrap';
import { chatList, markSeenAllMessages } from '../../Services/UserService';
import moment from 'moment';
import { useNavigate } from 'react-router';

const ChatList = () => {
    const [chatUsers, setChatUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const navigate = useNavigate();

    const getChatList = async () => {
        try {
            const response = await chatList();
            if (response.success) {
                setChatUsers(response.data);
            }
        } catch (error) {
            console.error("Error fetching chat list:", error);
        }
    };

    useEffect(() => {
        getChatList();
    }, []);

    const filteredUsers = chatUsers.filter(chat =>
        chat.full_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleMarkSeenMessages = async (chat) => {
        const passData = {
            sender_id: chat?.sender_id,
            receiver_id: chat?.receiver_id,
        };
        await markSeenAllMessages(passData);

        const admin = JSON.parse(localStorage.getItem("user"));
        const user_id = chat?.sender_id === admin?._id ? chat?.receiver_id : chat?.sender_id;

        navigate(`/user-chat/${user_id}`, {
            replace: true,
            state: { user_id: user_id, full_name: chat?.full_name },
        });
    };

    const chatItemStyle = {
        padding: '10px',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background 0.2s ease',
    };

    const hoverStyle = {
        backgroundColor: '#fff9e5',
    };

    const unreadDotStyle = {
        width: '10px',
        height: '10px',
        backgroundColor: 'red',
        borderRadius: '50%',
        marginLeft: 'auto',
        alignSelf: 'center',
    };

    return (
        <Fragment>
            <Breadcrumbs mainTitle='' parent='' title='' />

            <Container fluid={true}>
                <Row>
                    <Col sm='12'>
                        <Card>
                            <CardHeader>
                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <H5 className="mb-0">{'Chat List'}</H5>
                                <Input
                                type="text"
                                placeholder="Search by name"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{ width: '250px' }}
                                className="mt-2 mt-sm-0"
                                />
                            </div>
                            </CardHeader>
                            <CardBody>
                                {filteredUsers.length === 0 ? (
                                    <p>No chats found</p>
                                ) : (
                                    filteredUsers.map((chat, index) => (
                                        <div
                                            key={index}
                                            className="d-flex align-items-center mb-2"
                                            style={{
                                                ...chatItemStyle,
                                                ...(hoveredIndex === index ? hoverStyle : {})
                                            }}
                                            onMouseEnter={() => setHoveredIndex(index)}
                                            onMouseLeave={() => setHoveredIndex(null)}
                                            onClick={() => handleMarkSeenMessages(chat)}
                                        >
                                            <Media className="d-flex align-items-start w-100">
                                                <img
                                                    className="rounded-circle mr-3"
                                                    style={{ borderRadius: "2px" }}
                                                    src={chat.profile_picture}
                                                    alt={chat.full_name}
                                                    width="50"
                                                    height="50"
                                                />
                                                <Media body style={{ marginLeft: "16px" }}>
                                                    <h6 className="mb-1">{chat.full_name}</h6>
                                                    <p className="mb-0 text-muted">{chat.last_message}</p>
                                                    <small className="text-secondary">
                                                        {moment(chat.last_message_date).fromNow()}
                                                    </small>
                                                </Media>
                                            </Media>
                                            {!chat.last_message_is_seen && (
                                                <div style={unreadDotStyle}></div>
                                            )}
                                        </div>
                                    ))
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default ChatList;
